import Helper from './Helper';

class Jump {
  constructor(config = {}) {
    const {
      graphicSelector,
    } = config;

    this.graphicsSelector = document.querySelectorAll(graphicSelector);
    this.graphicsSelectorArray = Array.prototype.slice.call(this.graphicsSelector);
    if (this.graphicsSelector && this.graphicsSelectorArray.length !== 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    window.addEventListener('scroll', () => {
      this.graphicsSelectorArray.forEach(graphicItem => {
        this.toggleClassOnGraphic(graphicItem);
      });
    });
  }

  toggleClassOnGraphic(item) {
    if (Helper.isInViewport(item)) {
      item.addEventListener('scroll', () => {
        Helper.addClass(item, 'scrolled');
      });

      setTimeout(() => {
        if (!item.classList.contains('jump-animate') && !item.classList.contains('scrolled')) {
          Helper.addClass(item, 'jump-animate');
        }
      }, 2000);
    }
  }
}

export default Jump;
